import styled from 'styled-components';

import { Icon } from 'app/theme/Icons/Icon';
import { color } from 'app/theme/theme';

const IconStyled = styled(Icon)`
  &&&& {
    box-shadow: none;
    color: ${color.brickRed};
    font-size: 2.5rem;
  }
`;

export const EmailIcon = (): JSX.Element => (
  <div>
    <IconStyled circular name="mail" aria-label="mail" />
  </div>
);
